import VerificationsCreateTemplate from '@/pages/requests/creationPages/VerificationsCreateTemplate.vue'
import VerificationsDetailPage from '@/pages/requests/detailPages/VerificationsDetailPage.vue'
import VerificationsListPage from '@/pages/requests/VerificationsListPage.vue'

export default [
  {
    path: '/verifications/create/',
    alias: [],
    component: VerificationsCreateTemplate
  },
  {
    path: '/verifications/details/:id',
    alias: [],
    component: VerificationsDetailPage
  },
  {
    path: '/verifications/list/',
    alias: [],
    component: VerificationsListPage
  }
]
